import { registerPlugin, PluginListenerHandle } from '@capacitor/core';

/**
 * Én geofence-sone rundt en plass. Teksten bygges JS-side (i18n) og sendes med,
 * slik at native kan poste varselet selv når appen er lukket uten å kjenne til
 * oversettelser. `spotId` havner i varselets `extra` så tap kan rutes til
 * innsjekk-flyten (samme kontrakt som LocalNotifications: action `check_in`).
 */
export interface GeofenceRegion {
  spotId: string;
  latitude: number;
  longitude: number;
  radius: number;      // meter
  dwellMs: number;     // hvor lenge brukeren må bli før varsel (Android DWELL / iOS-timer)
  title: string;       // varseltittel (ferdig oversatt)
  body: string;        // varseltekst (ferdig oversatt, inkl. plassnavn)
}

export interface GeofenceCheckInPlugin {
  /** Har appen «Tillat hele tiden»-lokasjon (kreves for bakgrunns-geofence)? */
  checkPermissions(): Promise<{ granted: boolean }>;
  /** Be om «Tillat hele tiden»-lokasjon. Kan åpne systeminnstillinger. */
  requestPermissions(): Promise<{ granted: boolean }>;
  /** Erstatt alle aktive soner med denne lista (idempotent full re-registrering). */
  addGeofences(options: { geofences: GeofenceRegion[] }): Promise<void>;
  /** Fjern alle aktive soner. */
  removeAllGeofences(): Promise<void>;
  /**
   * Fyres når en dwell/enter-trigger slår til MENS appen lever. Når appen er
   * lukket poster native varselet selv; tap håndteres da via deeplink/intent.
   */
  addListener(
    eventName: 'checkInTriggered',
    listener: (event: { spotId: string }) => void,
  ): Promise<PluginListenerHandle>;
}

/**
 * Web/PWA har ingen OS-geofence — no-op. Trinn 1 (forgrunns-dwell i
 * spotProximity.runProximityCheckIn) dekker web/forgrunn uavhengig av dette.
 */
export const GeofenceCheckIn = registerPlugin<GeofenceCheckInPlugin>('GeofenceCheckIn', {
  web: {
    checkPermissions: async () => ({ granted: false }),
    requestPermissions: async () => ({ granted: false }),
    addGeofences: async () => {},
    removeAllGeofences: async () => {},
    addListener: async () => ({ remove: async () => {} }),
  },
});
